// export const API = "https://app.donorflow.net/api/v1"
// export const API = "http://localhost:3000/v1"
export const API = "https://api.donorflow.net/v1"

// export const DOMAIN = 'http://localhost:3000';
export const DOMAIN = 'https://api.donorflow.net';
// export const COOKIE_DOMAIN = 'localhost';
export const COOKIE_DOMAIN = 'donorflow.net';
// export const DOMAIN = 'http://localhost:3000';
export const DASHBOARD_ROOT = "https://app.donorflow.net"

export const authAPI = "https://hi.donorflow.net/api"

export const firebaseConfig = {
    apiKey: "AIzaSyAcI4gns2Wjug60RYR9bza15oeV2GSn3Sc",
    authDomain: "donorflow-v1-live.firebaseapp.com",
    databaseURL: "https://donorflow-v1-live.firebaseio.com",
    projectId: "donorflow-v1-live",
    storageBucket: "donorflow-v1-live.appspot.com",
    messagingSenderId: "521350199644",
    appId: "1:521350199644:web:6ca0c7f23d49e5383de999",
    measurementId: "G-HRFJ3EVEWQ",
};

export const endpointUrl = 'https://hi.donorflow.net'
// export const endpointUrl = 'https://hi.donorflow.net'

export const LOGIN_URL = "https://app.donorflow.net/login";